import React, { useState } from 'react'
import PileExecutedStatusChangerView from '../PileExecutedStatusChanger/View'
import PileExecutedCardItem from './Components/Item'
import PreboreSettingModal from '../Detail/Components/HoleList/PreboreSettingModal'

import useViewModel from './ViewModel'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { getPreboreFromHole, parsePreborePayload } from 'Utils/prebore'
import { toast } from 'react-toastify'

const ProjectPileExecutedListView: React.FC = () => {
  const {
    projectMachineOptions,
    data,
    projectId,
    onScan,
    onChangeStatus,
    onPrint,
    updatePileHolePrebore,
  } = useViewModel()
  const [openPreboreModal, setOpenPreboreModal] = useState(false)
  const [selectedPileHoleId, setSelectedPileHoleId] = useState<number | null>(null)
  const [isSavingPrebore, setIsSavingPrebore] = useState(false)

  const selectedHole =
    selectedPileHoleId != null ? data.find((item: any) => item.id === selectedPileHoleId) : null
  const selectedPrebore = getPreboreFromHole(selectedHole)

  const handleOpenPrebore = (pileHoleId: number) => {
    setSelectedPileHoleId(pileHoleId)
    setOpenPreboreModal(true)
  }

  const handleClosePreboreModal = () => {
    setOpenPreboreModal(false)
    setSelectedPileHoleId(null)
  }

  const handleSavePrebore = async (
    depth: string,
    drillSize: string,
    pileNo: string,
    gridLine: string,
    location: string
  ) => {
    if (!projectId || selectedPileHoleId == null) return
    setIsSavingPrebore(true)
    const { success, data: errData } = await updatePileHolePrebore(
      parseInt(projectId),
      selectedPileHoleId,
      parsePreborePayload(depth, drillSize, pileNo, gridLine, location)
    )
    setIsSavingPrebore(false)

    if (!success) {
      toast.error(errData)
      return
    }

    toast.success('บันทึกตั้งค่า prebore สำเร็จ')
    handleClosePreboreModal()
  }

  return (
    <React.Fragment>
      <PileExecutedStatusChangerView />

      <div className='card'>
        <div className='card-header'>
          <div className='card-title'>รายการรวมตอกเสาสำเร็จ</div>
          <div className='card-toolbar'></div>
        </div>

        <div className='card-body'>
          <div className='row g-10'>
            {data.map((item: any) => {
              const prebore = getPreboreFromHole(item)

              return (
                <PileExecutedCardItem
                  key={item.id}
                  {...item}
                  masterMachines={projectMachineOptions}
                  preboreDepth={prebore.preboreDepth}
                  preboreDrillSize={prebore.preboreDrillSize}
                  pileNo={prebore.pileNo}
                  gridLine={prebore.gridLine}
                  location={prebore.location}
                  onScan={onScan}
                  onPrint={onPrint}
                  onChangeStatus={onChangeStatus}
                  onOpenPrebore={handleOpenPrebore}
                />
              )
            })}
          </div>
        </div>
        <div className='text-center'>
          <Link className='mx-1' to={'/project/' + projectId + '/pile-execution'}>
            <Button variant='info'>ย้อนกลับ</Button>
          </Link>
          <Link className='mx-1' to={'/project/' + projectId + '/overview'}>
            <Button variant='info'>ไปยังโครงการ</Button>
          </Link>
        </div>
      </div>

      <PreboreSettingModal
        isOpen={openPreboreModal}
        handleClose={handleClosePreboreModal}
        initialDepth={
          selectedPrebore.preboreDepth != null ? String(selectedPrebore.preboreDepth) : ''
        }
        initialDrillSize={
          selectedPrebore.preboreDrillSize != null ? String(selectedPrebore.preboreDrillSize) : ''
        }
        initialPileNo={selectedPrebore.pileNo ?? ''}
        initialGridLine={selectedPrebore.gridLine ?? ''}
        initialLocation={selectedPrebore.location ?? ''}
        isSaving={isSavingPrebore}
        onSave={handleSavePrebore}
      />
    </React.Fragment>
  )
}

export default ProjectPileExecutedListView
